import { Children } from "@models/children.model"
import { BaseConverter } from "./BaseConverter"
import { ChildrenDto } from "@dtos/children.dto"

export class ChildrenConverter extends BaseConverter<Children, ChildrenDto>{
    modelToDto(model: Children): ChildrenDto {
        return new ChildrenDto(
            model.id,
            model.type
        )
    }

    dtoToModel(dto: ChildrenDto): Children {
        return new Children(
            dto.id,
            dto.type
        )
    }
}